import { render, staticRenderFns } from "./PosComponent.vue?vue&type=template&id=4969737b&"
import script from "./PosComponent.vue?vue&type=script&lang=js&"
export * from "./PosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports